export default "__VITE_ASSET__DpcW8RIk__"